export class FlagImgConstants {

    public static readonly FlagImageMap = {
        POLAND: "assets/images/poland.jpg",
        INDIA: "assets/images/india.jpg",
        FRANCE: "assets/images/france.jpg",
        ROMANIA: "assets/images/romania.jpg",
        JAPAN: "assets/images/japan.jpg",
        AUSTRALIA: "assets/images/australia.jpg",
        KSA: "assets/images/saudi.jpg",
        ITALY: "assets/images/italy.jpg",
        MALAYSIA: "assets/images/malaysia.jpg"
    }
}